<template>
  <div class="layout">
    <div v-wechat-title="($route.meta.title = exhibitionInfo.exhibition.nameEn || exhibitionInfo.exhibition.name)" v-if="exhibitionInfo && exhibitionInfo.exhibition"></div>
    <!-- <div class="bg_img">
      <div class="bg_mask"></div>
      <img v-if="bgUrl" :src="bgUrl" >
      <img v-else src="@assets/img/empty.png" >
    </div> -->
    <searchBar @search="openSearch = true" :placeholder="placeholder" :backgroundColor="backgroundColor" :theme="1"></searchBar>
    <div class="tab_nav">
      <!-- <div class="nav_item" :class="{ is_active: index == actIndex }" @click="tabChange(index)" v-for="(item, index) in navList" :key="index">s
        {{ item }}
        <div :class="{ xian: index == actIndex }"></div>
      </div> -->
      <div class="nav_item" :class="{ is_active: 0 == actIndex }" @click="tabChange(0)" v-if="enabledSupplyDemand">
        Supply&Demand
        <div :class="{ xian: 0 == actIndex }"></div>
      </div>
      <div class="nav_item" :class="{ is_active: 1 == actIndex }" @click="tabChange(1)" v-if="enabledArticle">
        News
        <div :class="{ xian: 1 == actIndex }"></div>
      </div>
      <div class="nav_item" :class="{ is_active: 2 == actIndex }" @click="tabChange(2)" v-if="enabledExhibitionSurvey">
        OverView
        <div :class="{ xian: 2 == actIndex }"></div>
      </div>
    </div>
    <div class="home_wrap">
      <!-- <exCard @requestOk="requestOk" ref="exCard" ></exCard> -->
      <!-- <div class="ex">
        <pageBanner :list="homeBanners"></pageBanner>
      </div> -->
      <div>
        <exinfo v-if="actIndex == 2"></exinfo>
        <news v-if="actIndex == 1"></news>
        <needs v-if="actIndex == 0"></needs>
      </div>
      <!-- 热门搜索 -->
      <!-- 热门搜索 -->
    </div>
    <searchPage :show="openSearch" :placeholder="placeholder" :type="rankingType" @callback="setSearch" ref="search"></searchPage>
    <layoutFooter></layoutFooter>

  </div>
</template>

<script>
import layoutFooter from "@components/layout-footer";
import gql from "graphql-tag";
import exCard from "./components/ex-card";
import navTab from "./components/navTab";
import pageBanner from "./components/pageBanner";
import { mapGetters } from "vuex";
import exinfo from "./components/exinfo";
import news from "../headlines/component/news";
import needs from "../headlines/component/needs2";
import searchBar from "@/components/searchBar";
import searchPage from "@/components/searchPage"; // 搜索页
export default {
  name: "home",
  data () {
    return {
      openSearch: false,
      exInfoIsOk: false, //展会信息是否加载完成
      bannersIsOk: false, //展会banner加载完成
      supplyIsOk: false, //供需加载完成
      exLiveIsOk: false, //专题直播加载完成
      compListIsOk: false, //品牌展商加载完成
      backgroundColor: "rgba(255,255,255,0)", //头部背景图
      isDown: false,
      bgUrl: "",
      scroll_: null,
      docTitle: "home",
      rankingType: "CompInfo", // 默认显示展商
      searchType: 0, // 搜索类型
      actIndex: 0,
      placeholder: "Exhibitors",
      homeBanners: [], //展会首页banner
      navList: ["Supply&Demand", "News", "OverView"],
      backgroundColor: "rgba(255,255,255,0)",
      isDown: true,
    };
  },
  components: {
    layoutFooter,
    exCard,
    navTab,
    pageBanner,
    exinfo,
    news,
    needs,
    searchBar,
    searchPage,
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "getExhibitionInfo",
      exhibitionId: "getExhibitionId",
      exhibitionConfig: "getExhibitionConfig",
      userId: "getUserId",
    }),
    enabledArticle () {
      return (
        this.exhibitionConfig &&
        this.exhibitionConfig.feature &&
        this.exhibitionConfig.feature.enabledArticle
      );
    },
    enabledSupplyDemand () {
      return (
        this.exhibitionConfig &&
        this.exhibitionConfig.feature &&
        this.exhibitionConfig.feature.enabledSupplyDemand
      );
    },
    enabledExhibitionSurvey () {
      return (
        this.exhibitionConfig &&
        this.exhibitionConfig.feature &&
        this.exhibitionConfig.feature.enabledExhibitionSurvey
      );
    },
  },
  created () {
    this.init();
    this.$Myapollo.addExhibitionView();
  },
  changeTab () {
    let query = this.$route.query;
    if (query && query.type && query.type === "Supply") {
      this.showTabs = "1";
    } else if (query && query.type && query.type === "hall") {
      this.showTabs = "2";
    }
  },
  mounted () {
    this.$Bus.$on("bannerChange", (imgUrl) => {
      this.bgUrl = imgUrl;
    });
    this.scroll_ = () => {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let apl = (scrollTop * 0.0215).toFixed(2);
      if (Math.abs(apl) > 0.99) {
        this.backgroundColor = "rgba(255,255,255,1)";
        this.isDown = true;
      } else if (Math.abs(apl) > 0.1) {
        this.backgroundColor = `rgba(255,255,255,${Math.abs(apl)})`;
        this.isDown = true;
      } else {
        this.backgroundColor = `rgba(255,255,255,0)`;
        this.isDown = false;
      }
    };
    window.addEventListener("scroll", this.scroll_);
  },
  beforeDestroy () {
    if (this.scroll_) {
      window.removeEventListener("scroll", this.scroll_);
    }
    this.$Bus.$off("bannerChange");
  },
  methods: {
    async init () {
      if (
        this.$router.history &&
        this.$router.history.current &&
        this.$router.history.current.query
      ) {
        this.actIndex = this.$router.history.current.query.actIndex || 0;
      }
      this.getBanners();
    },
    tabChange (i) {
      if (this.actIndex == i) {
        return;
      }
      this.actIndex = i;
      this.$Myapollo.addExhibitionView();
    },
    //展会banner
    getBanners () {
      const query = gql`
        query banners($exhibitionId: Guid!) {
          banners(exhibitionId: $exhibitionId, position: "show.page.home") {
            content
            covers
            enabledCountdown
            url
            endAt
            showIndex
            createAt
          }
        }
      `;
      this.$apollo.addSmartQuery("banners", {
        query: query,
        variables: {
          exhibitionId: this.exhibitionId,
        },
        fetchPolicy: "no-cache", //清理缓存
        result (res) {
          console.log("请求回来了banners", res);
          let data = JSON.parse(JSON.stringify(res.data.banners));
          if (data && data.length) {
            this.homeBanners = data;
            this.bgUrl = data[0].covers;
            console.log(this.homeBanners, "homeBanners");
          } else {
            console.log(this.exOnInfo, "haha");
            let demo = {
              content: "",
              url: "",
              covers: "",
              enabledCountdown: false,
            };
            this.homeBanners = [];
          }
          this.requestOk("requestOk", "bannersIsOk"); //banner获取完成
        },
        error (err) { },
      });
    },
    requestOk (okName) {
      this[`${okName}`] = true;
      let arr = [
        this.supplyIsOk,
        this.exLiveIsOk,
        this.compListIsOk,
        this.bannersIsOk,
      ];
      let isAllOk = arr.every((item) => {
        return item;
      });
      if (isAllOk) {
        this.$refs.nearEx.init();
        this.$refs.togetherAct.init();
        this.$refs.exTabList.init();
      }
    },

    shareClick () {
      this.$refs.exCard.share();
    },
    setSearch (e) {
      // 设置搜索值
      console.log(e, "设置搜索值");
      this.openSearch = false;
      this.searchText = e.txt;
      this.searchType = e.type; // 0为输入搜索，1为展馆，2为类别
      this.$store.commit("setSearch", this.searchText);
      if (this.searchText) {
        this.$router.push(
          `/exhibition/${this.exhibitionId}?search=${this.searchText}&searchType=${this.searchType}`
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  min-height: 100vh;
  position: relative;
  background-size: contain;
  padding-bottom: 55px;
  padding-top: calc(0.93rem + 0.9rem);
  background: #fff;
  .tab_nav {
    background: #fff;
    position: fixed;
    top: 0.93rem;
    left: 0;
    right: 0;
    height: 0.9rem;
    width: 100%;
    display: flex;
    z-index: 99;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    border-bottom: 1px solid #e6e6e6;
    .nav_item {
      color: #666;
      width: 2rem;
      height: 0.48rem;
      line-height: 0.48rem;
      text-align: center;
      border-radius: 0.48rem;
      font-size: 0.26rem;

      &.is_active {
        color: #1890ff;
        background: #fff;
      }
    }
    .xian {
      width: 0.54rem;
      height: 2px;
      background: #1890ff;
      margin: 0 auto;
    }
  }
  .ex {
    margin: 0 0.3rem;
    padding: 10px 0;
    background-color: #fff;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
  }
  .home_wrap {
    position: relative;
    z-index: 1;
  }
  .bg_img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 4.6rem;
    width: 100%;
    overflow: hidden;
    border-radius: 0 0 100% 100% / 0% 0% 10% 10%;
    .bg_mask {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background: rgba($color: #000, $alpha: 0.2);
    }
    img {
      height: 100%;
      width: 100%;
      display: block;
      filter: blur(5px);
      transform: scale(1.1);
    }
  }
}
</style>
